/* eslint-disable */
import isArray from '@dcode/is/array/array';
import slice from '~/utils/list/slice';
import mapContext from './mapContext';
import unproxy from './unproxy';

export function unproxyAll(context, methods) {
	const args = isArray(methods) ? methods : slice(arguments, 1);
	return mapContext(unproxy, context, args);
}

export default unproxyAll;
